import { render } from "./ConfigurationEmailLists.vue?vue&type=template&id=df1b0fda&scoped=true"
import script from "./ConfigurationEmailLists.vue?vue&type=script&lang=js"
export * from "./ConfigurationEmailLists.vue?vue&type=script&lang=js"

import "./ConfigurationEmailLists.vue?vue&type=style&index=0&id=df1b0fda&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df1b0fda"]])

export default __exports__